import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Components & Pages
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import AffiliateDirectory from './pages/AffiliateDirectory';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Agreement from './pages/Agreement';

function App() {
  // State for category filtering across the app
  const [selectedCategory, setSelectedCategory] = useState('All');

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-slate-50 font-sans">
        {/* Header manages the category selection for the directory */}
        <Header
          activeCategory={selectedCategory}
          onCategorySelect={setSelectedCategory}
        />

        <main className="flex-grow">
          <Routes>
            {/* Set Wholesale Directory as the Home Page */}
        
            {/* Alias for wholesale if you want to use sub-navigation */}
            <Route
              path="/"
              element={<AffiliateDirectory selectedCategory={selectedCategory} onCategorySelect={setSelectedCategory} />}
            />

            {/* Support Pages */}
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/agreement" element={<Agreement />} />

            {/* Redirect any broken links back to the main directory */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;